import { render } from "./ApproveRequest.vue?vue&type=template&id=565e0c8a"
import script from "./ApproveRequest.vue?vue&type=script&lang=js"
export * from "./ApproveRequest.vue?vue&type=script&lang=js"

import "./ApproveRequest.vue?vue&type=style&index=0&id=565e0c8a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__